import { render, staticRenderFns } from "./ContactUsCn.vue?vue&type=template&id=c1a386a4&scoped=true"
import script from "./ContactUsCn.vue?vue&type=script&lang=js"
export * from "./ContactUsCn.vue?vue&type=script&lang=js"
import style0 from "./ContactUsCn.vue?vue&type=style&index=0&id=c1a386a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a386a4",
  null
  
)

export default component.exports